import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom'

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Link from '@material-ui/core/Link';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';

import Loading from 'app/components/loaders/Loading';
import useApi from 'app/context/useApi';

import VaporExtension from 'app/utils/VaporExtension';
import FileExtensions from 'app/utils/FileExtensions';

const steps = ['Formatting Rules', 'Import Options', 'File Import', 'Import Status'];

const useStyles = makeStyles(theme => ({
    input: {
        display: 'none',
    },
    listSubHeader: {
        backgroundColor: '#ffffff',
        color: theme.palette.error.main
    },
    marginTop: {
        marginTop: theme.spacing(3)
    }
}));

export default function UserImportDialog(props) {

    const classes = useStyles();
    const api = useApi();

    const { open, onClose } = props;

    const [ activeStep, setActiveStep ] = useState(0);
    const [ importGroupId, setImportGroupId ] = useState(0);
    const [ importNotify, setImportNotify ] = useState(false);
    const [ welcome, setWelcome ] = useState("Welcome to your member portal. From here you can catch up on news, message members, view events and much more. We're glad you are here.");
    const [ levels, setLevels ] = useState([]);

    const [ file, setFile ] = useState(null);

    const [ importErrors, setImportErrors ] = useState([]);
    const [ importLoading, setImportLoading ] = useState(false);

    const getLevels = () => {
        setImportLoading(true);

        api.get('/admin/group/level')
            .then(res => {
                setLevels(res.groups);
            }).catch(error => {
                //console.log(error.response);
            }).then(() => setImportLoading(false));
    }

    useEffect(() => getLevels(), []);

    const handleImportGroupId = e => {
        const id = e.target.value;
        setImportGroupId(id);
    };

    const handleImportNotify = () => {
        setImportNotify(!importNotify);
    }

    const handleWelcome = e => setWelcome(e.target.value);

    const handleImportClose = () => {
        setActiveStep(0);
        setFile(null);
        setImportErrors([]);
        onClose();
    }

    const handleNext = () => {
        const nextStep = activeStep + 1;
        if (nextStep === 3) importUsers();
        else if (nextStep === 4) handleImportClose();
        else setActiveStep(nextStep);
    }

    const handleBack = () => {
        const previousStep = activeStep - 1;
        if (previousStep === -1) handleImportClose();
        else setActiveStep(previousStep);
    }

    const handleFile = () => {
        const fileInput = document.getElementById('import-input');
        setFile(fileInput.files[0]);
    }

    const getButtonText = () => {
        const step = activeStep
        if (step === 3) return 'Finish';
        if (step === 2) return 'Import';
        return 'Next';
    }

    const importUsers = () => {
        if (file) {

            setImportLoading(true);
            const token = api.defaults.headers.common['Authorization']

            VaporExtension.store(file, {}, token).then(response => {
                api.post('/admin/import/user', {
                    uuid: response.uuid,
                    url: response.url,
                    key: response.key,
                    extension: FileExtensions[file.type],
                    bucket: response.bucket,
                    notify: importNotify,
                    level_id: importGroupId,
                    welcome: welcome

                }).then(res => {
                    setActiveStep(3);
                    setImportErrors(res);
                }).finally(() => setImportLoading(false));
            });
        }
    }

    const hasImportErrors = () => {
        if (importErrors && importErrors.errors) return true;
        return false;
    }

    const hasImportFailures = () => {
        if (importErrors && importErrors.failures) return true;
        return false;
    }

    return (
        <Dialog
            open={open}
            onClose={handleImportClose}
            fullWidth
            maxWidth="sm"
            aria-labelledby="import-users-title"
            >
            <Loading isLoading={importLoading}/>
            <DialogTitle id="import-users-title">
                Import Users
            </DialogTitle>
            <DialogContent>
                <Stepper activeStep={activeStep} orientation="vertical">
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                            {(index == 0) &&
                                <StepContent>
                                    <Typography>
                                        The <b>IMPORT USERS</b> feature supports .XLSX, .CSV, .ODS, .TSV, and .XLS formats using the following columns: Prefix, First, Middle, Last, Suffix, Nickname, Marital Status, Spouse, Address One, Address Two, City, State, Zip, Work Address One, Work Address Two, Work City, Work State, Work Zip, Email, Phone Mobile, Phone Home, Phone Work, Notes, Deceased and Membership.
                                    </Typography>
                                </StepContent>
                            }
                            {(index == 1) &&
                                <StepContent>
                                        <TextField
                                            multiline
                                            rows="4"
                                            rowsMax="4"
                                            value={welcome}
                                            onChange={handleWelcome}
                                            fullWidth
                                            helperText="Message displayed to users the first time they log in."
                                            variant="outlined"
                                            label="New User Welcome Message"
                                            margin="normal"
                                            maxlength="191"
                                        />
                                        <TextField
                                            id="import-membership-level"
                                            select
                                            label="Membership Level"
                                            value={importGroupId}
                                            onChange={handleImportGroupId}
                                            helperText="Select a membership level to place the imported users in."
                                            variant="outlined"
                                            margin="normal"
                                            fullWidth
                                            >
                                            <MenuItem key={0} value={0}>
                                                Please select a Membership Level
                                            </MenuItem>
                                            {levels.map(level => (
                                                <MenuItem key={level.id} value={level.id}>
                                                    {level.title}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                        <FormControlLabel
                                            control={
                                                <Switch
                                                    checked={importNotify}
                                                    onChange={handleImportNotify}
                                                    color="primary"
                                                    value="importNotify"
                                                />
                                            }
                                            label="Notify users by email about there new account?"
                                            margin="normal"
                                            fullWidth
                                        />
                                        <br/>
                                        <Link component={NavLink} to="/admin/levels">
                                            Create / Edit Membership Levels
                                        </Link>
                                </StepContent>
                            }
                            {(index == 2) &&
                                <StepContent>
                                    <Grid container alignItems="center" spacing={2}>
                                        <Grid item>
                                            <input
                                                accept="*/*"
                                                className={classes.input}
                                                id="import-input"
                                                type="file"
                                                onChange={handleFile}
                                            />
                                            <label htmlFor="import-input">
                                                <Button component="span">
                                                    Open
                                                </Button>
                                            </label>
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle2" color="primary">
                                                { file ? file.name : 'none'}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </StepContent>
                            }
                            {(index == 3) &&
                                <StepContent>
                                    { hasImportErrors() ? (
                                        <List
                                            subheader={
                                                <ListSubheader className={classes.listSubHeader}>
                                                    Database Errors
                                                </ListSubheader>
                                            }
                                            >
                                            {importErrors.errors.map((error, index) => (
                                                <ListItem button key={index}>
                                                    <ListItemText primary={error} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    ) : (
                                        <Typography variant="subtitle2" color="primary" gutterBottom>
                                            No Import Errors.
                                        </Typography>
                                    )}
                                    { hasImportFailures() ? (
                                        <List
                                            subheader={
                                                <ListSubheader className={classes.listSubHeader}>
                                                    Validation Failures
                                                </ListSubheader>
                                            }
                                            >
                                            {importErrors.failures.map((failure, index) => (
                                                <ListItem button key={index}>
                                                    <ListItemText primary={failure.message} secondary={"Row: " + failure.row} />
                                                </ListItem>
                                            ))}
                                        </List>
                                    ) : (
                                        <Typography variant="subtitle2" color="primary" gutterBottom>
                                            No Import Failures.
                                        </Typography>
                                    )}
                                </StepContent>
                            }
                        </Step>
                    ))}
                </Stepper>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleBack}>
                    {activeStep === 0 ? 'Cancel' : 'Back'}
                </Button>
                <Button
                    onClick={handleNext}
                    variant="contained"
                    color={activeStep === 3 ? 'default' : 'primary'}
                    >
                    {getButtonText()}
                </Button>
           </DialogActions>
        </Dialog>
    )
}
